import { render, staticRenderFns } from "./Sim.vue?vue&type=template&id=408cfc96&scoped=true"
import script from "./Sim.vue?vue&type=script&lang=js"
export * from "./Sim.vue?vue&type=script&lang=js"
import style0 from "./Sim.vue?vue&type=style&index=0&id=408cfc96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408cfc96",
  null
  
)

export default component.exports